import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { getUrlByMenuItem } from "../Routes";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import HomeApi from "../../../api/homeApi";
import $ from "jquery";
import browserUtils from "@mnjsplatform/data/lib/utils/browserUtils";
import i18next from "i18next";
import {loadBadges} from "../../../actions/AppActions";

class LeftMenuItems extends Component {

  logout = (e) => {

    e.preventDefault();

    HomeApi.quitSession()
      .catch(()=>{})
      .then(()=>{AuthProvider.logout()});
  };

  componentDidMount() {

    const updateInterval = window.config.updateBadgeInterval ?? 5000;

    this.timer = setInterval(
      async () => {
        await this.props.dispatch(loadBadges());
      },
      updateInterval
    );
  }

  queryBadges() {
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  renderMenuItem = (menuItem) => {
    if (!!menuItem.ParentID || !menuItem.IsVisible)
      return null;

    if (menuItem.Type === 0) {
      return this.renderItem(menuItem);
    }
    else if (menuItem.Type === 1) {
      return this.renderGroupItem(menuItem, 0);
    }

    return null;
  }

  renderItem = (menuItem, commandParams) => {
    return (<div className="bd-toc-item" key={menuItem.MenuID} data-toggle="collapse" data-target="#bd-docs-nav.show">
      <Link className="bd-toc-link" to={getUrlByMenuItem(menuItem, commandParams)}>{menuItem.Text}
        {this.renderBadge(menuItem)}
      </Link>
    </div>);
  };

  renderGroupItem = (menuItem, level) => {
    const isExternalLinksGroup = menuItem.AppCommand && menuItem.AppCommand.CommandParams && menuItem.AppCommand.CommandParams.IsExternalLinksGroup == 1;
    const childMenuItems = this.getChildItems(menuItem);
    const groupId = "group_" + menuItem.MenuID;
    const groupParentId = "group_" + menuItem.MenuID + "_parent";

    const paddingLeftValue = (1.5 + 0.5 * level).toString() + "rem";

    //рендер ссылки на страницу ExternalLinks
    if (isExternalLinksGroup) {
      let mi = {...menuItem, Type: 0};
      return this.renderSubItem(mi, level);
    }
    return (<div className="bd-toc-item active" key={menuItem.MenuID}>
      <div className="menu-group-item-container">
        <a id={groupParentId} className="bd-toc-link collapsed" href={"#" + groupId}
           data-toggle="collapse" aria-expanded="false" aria-controls={groupId}
           style={{paddingLeft: paddingLeftValue}}
           onClick={(e)=>{e.preventDefault()}}
        >
          {menuItem.Text}
          {this.renderBadge(menuItem)}
        </a>
        <i className="menu-group-item-chevron zmdi zmdi-chevron-down" onClick={(e) => {e.preventDefault(); $("#" + groupParentId).trigger("click")}} />
        <i className="menu-group-item-chevron zmdi zmdi-chevron-up" onClick={(e) => {e.preventDefault(); $("#" + groupParentId).trigger("click")}} />
      </div>
      <ul className="nav bd-sidenav collapse" id={groupId}>
        {childMenuItems && childMenuItems.map(mi => this.renderSubItem(mi, level + 1))}
      </ul>
    </div>);
  };

  renderSubItem = (menuItem, level, commandParams) => {
    const isExternalLinksGroup = menuItem.AppCommand && menuItem.AppCommand.CommandParams && menuItem.AppCommand.CommandParams.IsExternalLinksGroup == 1;
//        console.log(`menuItem=[${JSON.stringify(menuItem)}], level=[${level}]`);
    if (menuItem.Type === 0 || isExternalLinksGroup) {
      const paddingLeftValue = (1.5 + 0.5 * level).toString() + "rem";

      return (<li key={menuItem.MenuID} data-toggle="collapse" data-target="#bd-docs-nav.show">
        <Link style={{paddingLeft: paddingLeftValue}} to={getUrlByMenuItem(menuItem, (isExternalLinksGroup ? {id: menuItem.MenuID} : null))}>{menuItem.Text}
          {this.renderBadge(menuItem)}
        </Link>
      </li>);
    }
    else if (menuItem.Type === 1) {
      return (<li key={menuItem.MenuID}>
        {this.renderGroupItem(menuItem, level)}
      </li>);
    }
    else if (menuItem.Type === 2) {
      return (<li key={menuItem.MenuID}>
        <div className="dropdown-divider"/>
      </li>);
    }
  };

  renderBadge = (menuItem) => {

    const b = this.getBadgeByMenuId(menuItem);
    if (!b)
      return null;

    const style = {};
    if (b.Color)
    {
      style["color"] = "#"+b.Color;
    }

    return <span className="bd-toc-badge" style={style}>{b.NumEDoc}</span>
  }

  getChildItems(menuItem) {
    return this.props.appState.menu.Items.filter(mi => mi.ParentID === menuItem.MenuID && mi.IsVisible);
  }

  getBadgeByMenuId(menuItem)
  {
    const menuID = menuItem.MenuID

    const b = this.props.appState.badges.find( b=>b.MenuId === menuID)
    if (!b)
      return null;

    return b;
  }

  render() {
    let style = {};
    if (browserUtils.isIE()) {
      style = {height: "100%", maxHeight: "100%"};
    }
    if (this.props.isDesktop) {
      style = { ...style, maxHeight: "calc(100vh - 76px)" };
    }
    return (
      <nav className="collapse bd-links mx-0" id="bd-docs-nav" style={style}>
        {this.props.appState.menu.Items.map(mi => this.renderMenuItem(mi))}
        <div className="bd-toc-item">
          <button type="button" className="btn bd-toc-link w-100" onClick={this.logout}>{i18next.t("Logout")}</button>
        </div>
        <div className="bd-toc-item">
            <span className="bd-toc-text">
                {this.props.appState.apiVersion + " " + this.props.appState.login}
            </span>
        </div>
      </nav>
    );
  }
}

LeftMenuItems.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired
};


LeftMenuItems.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state) {
  return {
    appState: state.appState.appParams
  };
}

export default withRouter(connect(mapStateToProps)(LeftMenuItems));